module.exports = __webpack_public_path__ + "media/images/covers/PrepWorks_Student-Testimonial_Nurazreen_Poster-127eb0422d3aa89265ed8494ca451be8.jpg";